
import { useNavigate } from "react-router";
import { useState } from "react";
import Logo from '../../images/axyma-logo.svg'
import Auth from '../../services/Auth';
import Login from "../../services/Login";
import { toast, ToastContainer } from 'react-toastify';
import { Oval } from 'react-loading-icons';
import { Button, IconButton, Stack, TextField } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LoginIcon from '@mui/icons-material/Login';

const loginService = new Login();

export default function FormLogin() {
  const navigate = useNavigate();
  const [user, setUser] = useState({ login: '', password: '' })
  const [inputType, setInputType] = useState("password");
  const [loading, setLoading] = useState(false);

  const saveLoginToken = async () => {
    try {
      const loginData = await loginService.getLoginInfo('/loginByToken', { email: user.login, senha: user.password })
      if (loginData) {
        return loginData;
      } if (!loginData) {
        throw new Error('Usuario invalido')
      } else return false;
    } catch (err) {
      const error: { message: string } = err as { message: string }
      throw new Error(error.message)
    }
  }

  const login = async () => {
    try {
      setLoading(true)
      const loginData = await saveLoginToken();
      if (loginData) {
        const auth = new Auth(loginData.uid, loginData.userName, loginData.empresa);
        await auth.getToken();
        const userData = await auth.confirmLoginAndGetData();
        if (userData) {
          if (userData.role.length === 13 && typeof window !== 'undefined') {
            window.localStorage.setItem('userData', JSON.stringify(userData));
            navigate("/empresas");
          } else throw new Error('Este usuário não tem permissão de acesso')
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const error: { message: string } = err as { message: string }
      throw new Error(error.message)
    }
  }

  const toggleEye = () => inputType === "password" ? setInputType("text") : setInputType("password")

  return (
    <Stack
      sx={{ backgroundColor: '#643e8f' }}
      direction='column'
      alignItems='center'
      justifyContent='center'
      width='100%'
      height='100svh'
      data-theme="light">
      <ToastContainer />
      <form onSubmit={async (event: React.FormEvent) => {
        event.preventDefault()
        await toast.promise(login(), {
          pending: 'Entrando...',
          success: 'Bem vindo!',
          error: 'Falha!'
        })
      }}
      >
        <Stack direction='column' width='100%' alignItems='center' justifyContent='center' spacing={1.5}>
          <span style={{ color: 'white' }}>Interface adminstrativa</span>
          <img
            src={Logo}
            width={200}
            height={200}
            alt="Axyma"
          />
          <TextField
            sx={{
              '& .MuiInputBase-root': {
                backgroundColor: 'white',
              },
            }}
            fullWidth
            required
            value={user.login}
            onChange={(event) => setUser({ ...user, login: event.target.value })}
            type="text"
            label="Nome de usuário"
          />
          <Stack direction='row'>
            <TextField
              sx={{
                '& .MuiInputBase-root': {
                  backgroundColor: 'white',
                },
              }}
              required
              value={user.password}
              onChange={(event) => setUser({ ...user, password: event.target.value })}
              type={inputType}
              label="Senha"
            />
            <IconButton onClick={toggleEye}>
              {inputType === "password"
                ? <VisibilityIcon />
                : <VisibilityOffIcon />}
            </IconButton>
          </Stack>
          <Button
            variant='contained'
            endIcon={<LoginIcon />}
            disabled={user.login === '' || user.password === ''}
            type="submit"
            className="button is-white">
            {loading
              ? <Oval height={10} speed={.5} stroke="#44c1cd" className="loading" />
              : 'Entrar'}
          </Button>
        </Stack>
      </form>
    </ Stack>
  );
}